import React from 'react';
import { getConfiguration } from '../data/utils/configuration';
import { useFetch } from '../data/fetch/useFetch';
import { parseExtraEvents } from '../data/parseExtraEvent';
import { usePrematchData } from '../prematch/PrematchDataProvider';
import Loader from '../common/Loader';
import TournamentEvent from '../prematch/TournamentEvent';
import MatchHeader from './MatchHeader';

function Matches(props) {
    const itemsByHeader = new Map();
    props.matches.map(sport =>
        sport.map(match => {
            const headerId = `${match.sportRef}_${match.tournamentRef}_${match.date}`;
            if (!itemsByHeader.has(headerId)) {
                itemsByHeader.set(headerId, []);
            }
            itemsByHeader.get(headerId).push(match);
        })
    );

    const groups = Array.from(itemsByHeader);

    return (
        <>
            {groups.map(group => {
                const [id, matches] = [group[0], group[1]]
                const firstMatch = matches[0];
                return (
                    <MatchHeader key={id} match={firstMatch} toggled={true}>
                        {matches.map(match =>
                            <TournamentEvent key={match.id} data={match} />
                        )}
                    </MatchHeader>
                );
            })}
        </>
    );
}

export default function BoostedOdds() {
    const conf = getConfiguration();
    const prematchData = usePrematchData();

    const [isLoading, isError, data] = useFetch(conf.api.getExtraEvents, null, (data) =>
        parseExtraEvents(prematchData, data)
    );

    if (isLoading) {
        return <Loader />;
    }

    return (
        <div className="l_3">
            <Matches matches={data.cota} />
            <Matches matches={data.extra} />
        </div>
    );
}
